/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Address_Does_Not_MatchInputs */



/**
* | output |
* | --- |
* | "Email address does not match" |
*
* @param {Email_Address_Does_Not_MatchInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const email_address_does_not_match = /** @type {((inputs?: Email_Address_Does_Not_MatchInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Address_Does_Not_MatchInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Email address does not match")
	return /** @type {LocalizedString} */ ("L'adresse email ne correspond pas")
});